import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper';
import 'swiper/css/pagination';
import 'swiper/css';
import starSvg from '../assets/icons/star.png'

export default function Slider({items,checked,type = ''}) {
    console.log(items)
  if(type === 'reviews'){
    return (
        <Swiper
        modules={[Pagination]}
        spaceBetween={50}
        slidesPerView={1}
        pagination={{ clickable: true ,currentClass:'test'}}
      >
        {items.map((card,index) => {
            return (
               <SwiperSlide key={index}>
                <div className='reviews__card'>
                    <div className="reviews__card-img">
                    </div>
                    <div className="reviews__card-name">
                        {card.name}
                    </div>
                    <div className="reviews__card-status">
                        {card.status}
                    </div>
                    <div className="reviews__card-rating">
                        <img src={starSvg} alt={'start'}/>
                        <img src={starSvg} alt={'start'}/>
                        <img src={starSvg} alt={'start'}/>
                        <img src={starSvg} alt={'start'}/>
                        <img src={starSvg} alt={'start'}/>
                    </div>
                    <div className="reviews__card-text">
                        {card.review}
                    </div>
                </div>
               </SwiperSlide>
            )
        })}
        </Swiper>
    )
  }

  return (
    <Swiper
    modules={[Pagination]}
    spaceBetween={50}
    slidesPerView={1}
    pagination={{ clickable: true ,currentClass:'test'}}
  >
    {items.map((card,index) => {
        return (
           <SwiperSlide key={index}>
             <div className={`pricing__card card${index}`} >
            {
                card?.popular
                ?
                <div className='pricing__card-label'>Most Popular</div>
                :
                <></>
            }
            <div className={'pricing__card-img' + index}>
                <img src={card.icon} alt={card.type}/>
            </div>
            <div className='pricing__card-type'>
                {card.type}
            </div>
            <div className='pricing__card-price'>
                {checked ? card.price : card.priceSecond} 
            </div>
            <div className='pricing__card-text'>
                {card.desc}
            </div>
            <ul className='pricing__card-features'>
                {
                card.features
                ?
                card.features.map((feature) => {
                    return (
                        <li key={feature} className='pricing__card-feature'>
                            {feature}
                        </li>
                    )
                })
                :
                <></>
                }
            </ul>
            {
                card?.popular
                ?
                <button className='pricing__card-blue-btn'>GET STARTED</button>
                :
                <button className='pricing__card-white-btn'>GET STARTED</button>
            }
            </div>
           </SwiperSlide>
        )
    })}
  </Swiper>
  )
}
